import { Theme, Typography } from "@material-ui/core"
import Grid from "@material-ui/core/Grid"
import makeStyles from "@material-ui/core/styles/makeStyles"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import TextField from "@material-ui/core/TextField"
import React, { Fragment } from "react"
import FieldSelect from "Components/Table/FieldSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import { useCreateEatDraft } from "./hooks"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        width: "100%",
        height: "100%",
    },
    timeBlock: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 20,
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
}))

const EatDraftCreate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback, dialogData, isBusiness,
        disabled,
        text, handleChange,
        handleChangeArticleType,
        projectId, projectMoney, handleProjectIdChange, handleProjectMoneyChange,
    } = useCreateEatDraft()

    return (
        <Fragment>
            <BoardConfirmModal
                title="创建备选预约"
                confirmCallback={callback}
                cancelCallback={cancelCallback}
                modalShow={dialogData.show}
                disabled={disabled}
            >
                <Grid container direction="column" justify="center">
                <TextField
                    label="预约说明"
                    value={text}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item>
                <FormControl className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        staticValueList={[]}
                        tableName="eat_article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>

            {
                // 创建时，只对商务部展示项目编号及项目金额
                isBusiness ? (
                    <>
                        <Grid container direction="column" justify="center">
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                                error={!!(projectId && projectId.length > 50)}
                                helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center">
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                                error={!!(projectMoney && projectMoney.length > 50)}
                                helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                    </>
                ) : null
            }
            </BoardConfirmModal>
        </Fragment>
    )
}

export default EatDraftCreate
